import { type ClassValue, clsx } from 'clsx'

import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  // use the `extend` key in case you want to extend instead of override
  extend: {
    classGroups: {
      'font-size': [
        'text-h1-500',
        'text-h1-400',
        'text-h2-500',
        'text-h2-400',
        // Legacy /600 heading tokens: alive only in the pinned chat widget
        // (tailwind.widget-pin.js), which shares this cn().
        'text-h1-600',
        'text-h2-600',
        'text-xl-500',
        'text-h3-600',
        'text-h3-500',
        'text-h3-400',
        'text-h4-500',
        'text-h4-600',
        'text-h4-400',
        'text-p-600',
        'text-p-500',
        'text-p-400',
        'text-s-600',
        'text-s-500',
        'text-s-400',
        'text-xs-600',
        'text-xs-500',
        'text-pi-400',
        'text-xs-400',
        'text-xsi-400',
        'text-xxs-400',
        'text-xxs-600',
        // Every custom fontSize token MUST be listed here. twMerge otherwise
        // reads `text-<name>` as a text COLOR, so a later colour class in the
        // same cn() silently deletes it and the element falls back to
        // preflight's `font-size: 100%` (16px on a button).
        'text-label',
      ],
      shadow: ['shadow-sh', 'shadow-sh1'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
